import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from '@mui/material';

function MonitorIframe({ username, password }) {

    const [open, setOpen] = useState(false);
    const [iframeUrl, setIframeUrl] = useState('');

    useEffect(() => {

        // ไม่มี password
        if (!password) {
            setIframeUrl('');
            setOpen(true);
            return;
        }

        // มี password
        const url = new URL(
            'https://monitor01.sitgps.com/'
        );

        url.searchParams.set(
            'username',
            username || ''
        );

        url.searchParams.set(
            'password',
            password
        );

        setIframeUrl(url.toString());
        setOpen(false);

    }, [username, password]);


    return (
        <>
            {/* ================================= */}
            {/* Monitor */}
            {/* ================================= */}

            {iframeUrl && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: '400px',
                        overflow: 'hidden',
                        margin: 0,
                        padding: 0,
                    }}
                >
                    <iframe
                        src={iframeUrl}
                        title="Monitor"
                        scrolling="yes"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            border: 'none',
                            display: 'block',
                            margin: 0,
                            padding: 0,
                        }}
                    />
                </div>
            )}


            {/* ================================= */}
            {/* Popup */}
            {/* ================================= */}

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        textAlign: 'center',
                        p: 1,
                    }
                }}
            >

                <DialogTitle sx={{ pt: 3 }}>

                    <Typography
                        variant="h6"
                        fontWeight="bold"
                    >
                        ไม่สามารถเปิด Monitor ได้
                    </Typography>

                </DialogTitle>


                <DialogContent>

                    <Typography color="text.secondary">
                        ไม่พบ Password กรุณา เข้าสู่ระบบ ใหม่อีกครั้ง
                    </Typography>

                </DialogContent>


                <DialogActions
                    sx={{
                        justifyContent: 'center',
                        pb: 2,
                    }}
                >

                    <Button
                        variant="contained"
                        onClick={() => setOpen(false)}
                        sx={{
                            minWidth: 120,
                            borderRadius: 2,
                            backgroundColor: '#2196f3',

                            '&:hover': {
                                backgroundColor: '#1976d2',
                            },
                        }}
                    >
                        ตกลง
                    </Button>

                </DialogActions>

            </Dialog>
        </>
    );
}

export default MonitorIframe;